import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, commonIdGetCustomTokenFeatureKey } from '../../reducers/common-id/common-id-get-custom-token.reducer';

const selectCommonIdGetCustomTokenState = createFeatureSelector<State>(commonIdGetCustomTokenFeatureKey);

export const getCustomToken = createSelector(selectCommonIdGetCustomTokenState, state => state.getCustomTokenResult);
